<template>
  <VLayout v-if="isDashboardVisible">
    <!-- customer -->

    <template #customer-title>
      <VTitle :title="$t('common.btnSearchCustomer')" :right="isCustomerSearchAllowed" :route="CUSTOMER_SEARCH">
        {{ $t('common.customerTitle') }}
      </VTitle>
    </template>

    <template #customer-collapsed>
      <VShort :visible="isCustomer">
        <div v-if="mapSalutation || firstname || name" data-test="row1">
          {{ mapSalutation }} {{ firstname }} {{ name }}
          <!-- #D9 + #D8 + #D7 -->
        </div>
        <div data-test="row2">
          <template v-if="customerNo">
            {{ $t('common.customerNo') }}: {{ customerNo }} ({{ $t('common.crm_' + crm) }})
            <!-- #S25 + #D11 + #S449 -->
          </template>
          <template v-else>
            {{ $t('common.crm_' + crm) }}
            <!-- #S449 -->
          </template>
        </div>
      </VShort>
    </template>

    <template #customer-expanded>
      <template v-if="isCustomer">
        <dl class="list-desc-grid list-desc-semibold list-desc-grid-left">
          <template v-if="wholesalerId">
            <dt v-html="$t('common.provider') + ':'"><!-- #S19 --></dt>
            <dd>
              {{ wholesalerName }} (ID: {{ wholesalerId }})
              <!-- #D5 + #S444 + #D294 -->
            </dd>
          </template>

          <dt>
            {{ $t('common.customerSegment') }}:
            <!-- #S20 -->
          </dt>
          <dd>
            {{ $t('common.crm_' + crm) }}
            <!-- #S449 -->
          </dd>
        </dl>

        <dl v-if="name || firstname || formatDateOfBirth" class="list-desc-grid list-desc-semibold list-desc-grid-left">
          <template v-if="name">
            <dt>
              {{ $t('common.name') }}:
              <!-- #S21 -->
            </dt>
            <dd>
              {{ name }}
              <!-- #D7 -->
            </dd>
          </template>

          <template v-if="firstname">
            <dt>
              {{ $t('common.firstname') }}:
              <!-- #S22 -->
            </dt>
            <dd>
              {{ firstname }}
              <!-- #D8 -->
            </dd>
          </template>

          <template v-if="mapSalutation">
            <dt>
              {{ $t('common.salutation') }}:
              <!-- #S23 -->
            </dt>
            <dd>
              {{ mapSalutation }}
              <!-- #D9 -->
            </dd>
          </template>

          <template v-if="formatDateOfBirth">
            <dt>
              {{ $t('common.birthdate') }}:
              <!-- #S24 -->
            </dt>
            <dd
              >{{ formatDateOfBirth }}
              <!-- #D10 -->
            </dd>
          </template>
        </dl>

        <dl v-if="customerNo || vbkz" class="list-desc-grid list-desc-semibold list-desc-grid-left">
          <template v-if="customerNo">
            <dt>
              {{ $t('common.customerNo') }}:
              <!-- #S25 -->
            </dt>
            <dd>
              {{ customerNo }}
              <!-- #D11 -->
            </dd>
          </template>

          <template v-if="vbkz">
            <dt>
              {{ $t('common.vbkz') }}:
              <!-- #S26 -->
            </dt>
            <dd>
              {{ vbkz }}
              <!-- #D12 -->
            </dd>
          </template>
        </dl>
      </template>

      <div v-else class="col s12 empty"> ({{ $t('common.empty') }}) </div>
    </template>

    <!-- contract -->

    <template #contract-title>
      <VTitle :title="$t('common.btnSearchContract')" :right="isContractSearchAllowed" :route="CONTRACT_SEARCH">
        {{ $t('common.contract') }}
      </VTitle>
    </template>

    <template #contract-collapsed>
      <VShort :visible="isContract">
        {{ tariffName }} ({{ mappedStatusShort }})
        <!-- #D13 + #D15 -->
        <div v-if="hasValidIdentifier" data-test="row2">
          {{ $t('common.NIK0') }}: {{ identifierInfo.NIK0.name }} - {{ identifierInfo.NIK0.value }}
          <!-- #S446 + #D20 + #D21 -->
        </div>
      </VShort>
    </template>

    <template #contract-expanded>
      <template v-if="isContract">
        <dl class="list-desc-grid list-desc-semibold list-desc-grid-left">
          <template v-if="tariffName || tariffId">
            <dt>
              {{ $t('common.tariff') }}:
              <!-- #S29 -->
            </dt>
            <dd>
              {{ tariffName }} ({{ $t('common.dashboard_customer_service_provider_id_label') }}: {{ tariffId }})
              <!-- #S445 + #D295 -->
            </dd>
          </template>

          <template v-if="contractSegment">
            <dt>
              {{ $t('common.contractSegment') }}:
              <!-- #S30 -->
            </dt>
            <dd>
              {{ contractSegment }}
              <!-- #D14 -->
            </dd>
          </template>

          <dt>
            {{ $t('common.status') }}:
            <!-- #S31 -->
          </dt>
          <dd>
            {{ mappedStatus }}
            <!-- #D15 -->
          </dd>
        </dl>

        <dl v-if="invoiceNumber || groupKey || phone" class="list-desc-grid list-desc-semibold list-desc-grid-left">
          <template v-if="invoiceNumber">
            <dt>
              {{ $t('common.invoiceNo') }}:
              <!-- #S32 -->
            </dt>
            <dd>
              {{ invoiceNumber }}
              <!-- #D16 -->
            </dd>
          </template>

          <template v-if="groupKey">
            <dt>
              {{ $t('common.groupKey') }}:
              <!-- #S33 -->
            </dt>
            <dd>
              {{ groupKey }}
              <!-- #D17 -->
            </dd>
          </template>

          <template v-if="phone">
            <dt>
              {{ $t('common.phone') }}:
              <!-- #S34 -->
            </dt>
            <dd>
              {{ phone }}
              <!-- #D18 -->
            </dd>
          </template>
        </dl>

        <template v-if="hasValidIdentifier">
          <h4 class="list-desc-grid-left-label">
            <small>
              {{ $t('common.dashboard_contract_identifiers_label') }}
              <!-- #S35 -->
            </small>
          </h4>
          <dl class="list-desc-grid list-desc-semibold list-desc-grid-left" style="margin-top: 0">
            <dt>
              {{ $t('common.NIK0') }}:
              <!-- #S446 -->
            </dt>
            <dd>
              {{ identifierInfo.NIK0.name }} - {{ identifierInfo.NIK0.value }}
              <!-- #D20 + #D21 -->
            </dd>

            <template v-if="identifierInfo.NIK1">
              <dt>
                {{ $t('common.NIK1') }}:
                <!-- #S447 -->
              </dt>
              <dd>
                {{ identifierInfo.NIK1.name }} - {{ identifierInfo.NIK1.value }}
                <!-- #D296 + #D297 -->
              </dd>
            </template>

            <template v-if="identifierInfo.IK">
              <dt data-test="IK">
                {{ $t('common.IK') }}:
                <!-- S448 -->
              </dt>
              <dd>
                {{ identifierInfo.IK.name }} - {{ identifierInfo.IK.value }}
                <!-- #D298 + #D299 -->
              </dd>
            </template>
          </dl>
        </template>
      </template>

      <div v-else class="col s12 empty"> ({{ $t('common.empty') }}) </div>
    </template>
  </VLayout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { CUSTOMER_SEARCH, CONTRACT_SEARCH } from '@route-types';
import { mapContractState } from '@/utils/i18n';
import { dateInputFormat, getLocalizedDateTimeOutputFormat } from '@/utils/date';

export default {
  name: 'Dashboard',

  components: {
    VLayout: () => import('./Layout'),
    VTitle: () => import('./Title'),
    VShort: () => import('./Short'),
  },

  data() {
    return {
      localeMapSalutation: null,
      CUSTOMER_SEARCH,
      CONTRACT_SEARCH,
    };
  },

  computed: {
    isCustomer() {
      return !!(this.customerNo || this.vbkz || this.name || this.wholesalerId);
    },

    formatDateOfBirth() {
      return getLocalizedDateTimeOutputFormat(this.$t('common.dateFormat'), dateInputFormat, this.dateOfBirth);
    },

    mapSalutation() {
      // don't fill salutation if there is no customer data
      if (!this.name) {
        return null;
      }

      if (this.salutation === null) {
        return this.$t('common.contractSalutation_1');
      }

      if (this.$te(`common.contractSalutation_${this.salutation}`)) {
        return this.$t(`common.contractSalutation_${this.salutation}`);
      }

      return this.$t('common.contractSalutation_unknown');
    },

    mappedStatus() {
      return mapContractState(this.status);
    },

    mappedStatusShort() {
      let statusDescription = this.mappedStatus.toString();
      if (statusDescription !== null) {
        const idx = statusDescription.indexOf('(');
        if (idx > 1) {
          statusDescription = statusDescription.substring(0, idx - 1);
        }
      }
      return statusDescription;
    },

    ...mapState('customer', ['name', 'firstname', 'salutation', 'dateOfBirth', 'customerNo', 'vbkz']),

    ...mapState('contract', [
      'contractSegment',
      'status',
      'tariffName',
      'tariffId',
      'invoiceNumber',
      'groupKey',
      'phone',
      'wholesalerId',
      'wholesalerName',
      'identifierInfo',
    ]),

    ...mapState('system', ['crm']),

    ...mapGetters('system', ['isDashboardVisible', 'isCustomerSearchAllowed', 'isContractSearchAllowed']),

    ...mapGetters('contract', ['isContract', 'hasValidIdentifier']),
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

@media screen and (min-width: 400px) and (max-width: 639px) {
  dl.list-desc-grid-left {
    display: flex;
    flex-wrap: wrap;
  }

  .list-desc-grid-left dt {
    width: 33.33334%;
    text-align: left;
  }
  .list-desc-grid-left dd {
    width: calc(66.6% - 12px);
    margin-left: 6px;
  }
}

@media screen and (min-width: 800px) and (max-width: 1024px) {
  dl.list-desc-grid-left {
    display: flex;
    flex-wrap: wrap;
  }

  .list-desc-grid-left dt {
    width: 33.33334%;
    text-align: left;
  }
  .list-desc-grid-left dd {
    width: calc(66.6% - 12px);
    margin-left: 6px;
  }
}

.empty {
  padding: 24px;
  color: $color-muted;
  text-align: center;
}
</style>
